// extracted by mini-css-extract-plugin
export var productImage = "_ws-0";